"use client";
import React, { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { endNProgess, startNProgress } from "@/utils/functions";

const Loader = () => {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        const handleStart = () => startNProgress();
        const handleStop = () => endNProgess();
        handleStop();

        return () => {
            handleStart();
        };
    }, [pathname, searchParams]);

    return <></>;
};

export default Loader;